export const signIn = (credentials, firebase) => {
  return async (dispatch, getState, { getFirestore }) => {
    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(credentials.email, credentials.password);
      dispatch({ type: "LOGIN_SUCCESS" });
    } catch (err) {
      console.error(err);
      dispatch({ type: "LOGIN_FAILED" });
    }
  };
};

export const signOut = firebase => {
  return async (dispatch, getState, { getFirestore }) => {
    try {
      console.log("signed out");
      await firebase.auth().signOut();
      dispatch({ type: "SIGNOUT_SUCCESS" });
    } catch (err) {
      console.log(err);
    }
  };
};

export const signUp = (newUser, firebase) => {
  return async (dispatch, getState, { getFirestore }) => {
    try {
      console.log("Signed in successfully");
      await firebase.auth().createUserWithEmailAndPassword(
        newUser.email,
        newUser.password
      ).then(async (resp) => {
        const firestore = getFirestore();
        console.log('there is a new user', newUser);
        await firestore.collection('users').doc(resp.user.uid).set({
           firstName: newUser.firstname,
           lastName: newUser.lastname
        })
      });
      dispatch({ type: "SIGNUP_SUCCESS" });
    } catch (err) {
      dispatch({ type: "SIGNUP_ERROR", err });
    }
  };
};
